<template>
    <div>
        <h1>BRIDGESTONE <span class="text-danger">PLUS</span></h1>
    </div>
</template>

<script></script>

<style scoped>
.bs-logo {
    max-width: 300px;
}
</style>